@if (sideNavService.version() === "vfo1") {
  <a
    [routerLink]="route()"
    class="tw-relative tw-grow tw-flex tw-p-3 tw-rounded-xl tw-outline-none focus-visible:tw-ring focus-visible:tw-ring-inset focus-visible:tw-ring-border-nav-focus focus-visible:tw-bg-bg-nav-hover hover:tw-bg-bg-nav-hover [&_svg]:tw-w-[153px]"
    [class]="!sideNavService.open() ? '[&_svg]:!tw-w-[20px]' : ''"
    [attr.aria-label]="label()"
    [title]="label()"
    routerLinkActive
    ariaCurrentWhenActive="page"
  >
    <div class="tw-flex tw-justify-center tw-items-center" aria-hidden="true">
      <i class="tw-w-6 bwi bwi-lg {{ closedIcon() }}"></i>
      <span class="tw-truncate" *ngIf="sideNavService.open()">{{ label() }}</span>
    </div>
  </a>
} @else {
  <div
    class="tw-px-2 tw-bg-bg-nav"
    [ngClass]="{
      'tw-sticky tw-top-0 tw-z-50 tw-pb-4': sideNavService.open(),
      'tw-pb-[calc(theme(spacing.8)_+_2px)]': !sideNavService.open(),
      'tw-pt-[calc(0.5rem_+_var(--bit-sidenav-extra-top-padding,_0px))]':
        sideNavService.isOverlay(),
      'tw-pt-2': !sideNavService.isOverlay(),
    }"
  >
    <!-- absolutely position the link svg to avoid shifting layout when sidenav is closed -->
    <a
      [routerLink]="route()"
      class="tw-relative tw-p-3 tw-block tw-rounded-md tw-bg-transparent tw-outline-none tw-font-bold tw-h-full hover:tw-no-underline focus-visible:tw-ring focus-visible:tw-ring-inset focus-visible:tw-ring-text-alt2 hover:tw-bg-hover-contrast"
      [class]="!sideNavService.open() ? '!tw-h-[55px] [&_svg]:!tw-w-[26px]' : ''"
      [attr.aria-label]="label()"
      [title]="label()"
      routerLinkActive
      ariaCurrentWhenActive="page"
    >
      <div class="tw-flex tw-justify-center tw-items-center" aria-hidden="true">
        <i class="tw-w-6 bwi bwi-lg {{ closedIcon() }}"></i>
        <span class="tw-truncate" *ngIf="sideNavService.open()">{{ label() }}</span>
      </div>
    </a>
  </div>
}
